// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"baq_a","InstagramEmbed__mask":"baq_b bhi_bi bhi_bo bhi_wx"};